var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"category"},[_c('router-link',{staticClass:"link",attrs:{"to":_vm.url}},[_c('h3',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('ItemCount',{attrs:{"count":_vm.count}}),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("\n      "+_vm._s(_vm.description)+"\n    ")]),_vm._v(" "),_c('img',{staticClass:"photo",attrs:{"src":_vm.photo}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-410917e6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CategoryListItem.vue
// module id = 686
// module chunks = 0